import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { forkJoin } from 'rxjs/observable/forkJoin';

import {
  MatTableDataSource,
  MatSort,
  MatPaginator,
  MatTable
} from '@angular/material';

import { DictionariesService } from '../../../../_services/dictionaries.service';
import { ConfirmationDialogService } from '../../../../_services/confirmation-dialog.service';
import { LanguageService } from '../../../../_services/language.service';

import { DictionaryFile } from '../../../../models/dictionary-file';
import { Type } from '../../../../models/index';
import { IndexAliasService } from './../../../../_services/index-alias.service';

@Component({
  selector: 'fury-stopwords',
  templateUrl: './stopwords.component.html',
  styleUrls: ['./stopwords.component.scss']
})
export class StopwordsComponent implements OnInit {
  loading = false;
  stopwordsList: DictionaryFile[] = [];
  languages: Type[];
  displayedColumns = ['nome'];

  form: FormGroup;
  file: File;

  @ViewChild('table') table: MatTable<DictionaryFile>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource: MatTableDataSource<DictionaryFile>;
  hasSentFile: boolean;
  isUploadingFile: boolean;

  constructor(
    private fb: FormBuilder,
    private dictionariesService: DictionariesService,
    private confirmationDialogService: ConfirmationDialogService,
    private indexAliasService: IndexAliasService,
    public languageService: LanguageService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.initPage();
  }

  private initPage(): void {
    const stopwordsListApi = this.dictionariesService.getStopwordsList();
    const stopwrodsLangApi = this.dictionariesService.getLanguages();
    forkJoin([stopwordsListApi, stopwrodsLangApi])
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(response => {
        if (response[0]) {
          this.stopwordsList = response[0];
        }
        if (response[1]) {
          this.languages = response[1];
        }

        this.initTable();
        this.initForm();
      });
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.stopwordsList);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  private initForm(): void {
    this.file = null;

    this.form = this.fb.group({
      file: [null, Validators.required],
      language: [null, Validators.required]
    });
  }

  applyFilter(filter: string): void {
    this.dataSource.filter = filter.trim().toLowerCase();
  }

  onFileChanged(event): void {
    if (event.target.files && event.target.files.length) {
      this.file = <File>event.target.files[0];
    }
  }

  sendForm(): void {
    this.confirmationDialogService
      .confirm(
        `${this.languageService.getLabel(
          'dictionaries.SendFormPrimoMessaggio'
        )}. ` +
        `${this.languageService.getLabel(
          'dictionaries.SendFormPrimoTitolo'
        )}?`,
        `${this.languageService.getLabel(
          'dictionaries.SendFormPrimoBottoneConferma'
        )}`
      )
      .then(res => {
        if (!res) {
          return;
        }

        this.confirmationDialogService
          .confirm(
            `${this.languageService.getLabel(
              'dictionaries.SendFormSecondoMessaggio'
            )}`,
            `${this.languageService.getLabel(
              'dictionaries.SendFormSecondoTitolo'
            )}`,
            `${this.languageService.getLabel('general.Conferma')}`,
            `${this.languageService.getLabel('general.Annulla')}`,
            'sm',
            `${this.languageService.getLabel(
              'dictionaries.SendFormSecondoPattern'
            )}`
          )
          .then(textRes => {
            if (!textRes) {
              return;
            }

            this.isUploadingFile = true;
            this.dictionariesService
              .saveStopwordsFile(this.form, this.file)
              .pipe(finalize(() => (this.isUploadingFile = false)))
              .subscribe(response => {
                if (response) {
                  this.confirmationDialogService.confirm(
                    `${this.languageService.getLabel(
                      'dictionaries.ApplicaModificheMessaggio'
                    )}`,
                    '',
                    `${this.languageService.getLabel('general.OK')}`,
                    '',
                    'sm',
                    null,
                    false
                  );
                  this.hasSentFile = true;
                  this.initPage();
                }
              });
          });
      });
  }

  downloadFile(file: DictionaryFile): void {
    this.dictionariesService.downloadFile(file.id).subscribe(response => {
      const blob = new Blob([response], { type: 'txt' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = file.filename;
      link.click();
    });
  }

  applyChanges(): void {
    this.confirmationDialogService.confirm(
      `${this.languageService.getLabel(
        'dictionaries.ApplicaModificheConfermaMessage'
      )}`,
      '',
      `${this.languageService.getLabel('general.OK')}`,
      null,
      'sm',
      null,
      false
    );
  }
}
